import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';

import CollectionsAndRemittances from './containers/collections-and-remittances/CollectionsAndRemittances'
import DailyCollectionSummary from './containers/daily-collection-summary/DailyCollectionSummary'

function MiscellaneousFeeReports({ match, pathName }) {
  const permissions = getJson('permissions');
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              {Acl(permissions, ['VIEW MISC FEES REPORTS COLLECTIONS AND REMITTANCES']) && (
                <li className="nav-item">
                  <Link
                    to="/miscellaneous-fees/reports/collections-and-remittances"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('/miscellaneous-fees/reports/collections-and-remittances') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Collections & Remittances
                  </Link>
                </li>
              )}
              <li className="nav-item">
                <Link
                  to="/miscellaneous-fees/reports/summary-of-daily-collection"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('/miscellaneous-fees/reports/summary-of-daily-collection') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Summary of Daily Collection
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => {
              if (Acl(permissions, ['VIEW MISC FEES REPORTS COLLECTIONS AND REMITTANCES'])) {
                return <Redirect to={`${match.path}/collections-and-remittances`} />
              }

              return <Redirect to={`${match.path}`} />
            }}
          />
          {Acl(permissions, ['VIEW MISC FEES REPORTS COLLECTIONS AND REMITTANCES']) && (
            <Route
              path={`${match.path}/collections-and-remittances`}
              component={CollectionsAndRemittances}
            />
          )}
          <Route
            path={`${match.path}/summary-of-daily-collection`}
            component={DailyCollectionSummary}
          />
        </Switch>
      </div>
    </React.Fragment>
  );
}

MiscellaneousFeeReports.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(MiscellaneousFeeReports);
